module.exports = __webpack_public_path__ + "static/assets/17b20e238552e00772bee085bda0b094.png";